import React from "react"
import { useProductCard } from "packages/core-shopping/hooks/useProductCard"
import { ProductBadge } from "packages/ui-shared/components/ProductBadge"

export const ProductCardBadge: React.FC = () => {
  const { productCardData } = useProductCard()
  if (!productCardData.badge) return null
  if (!productCardData.image.src) return null
  return (
    <ProductBadge
      src={productCardData.badge.src}
      alt={productCardData.badge.alt}
    />
  )
}
